import React from 'react'
import { PopupWidget } from "react-calendly";
import Form from '../components/Form'
import { Helmet } from 'react-helmet-async'

function IT_service() {
  return (
    <>
          <Helmet>
            <title> IT Support Services</title>
             <meta name="description" content="Our team of experienced professionals is dedicated to providing exceptional I.T. support. We prioritize customer satisfaction, offering customized solutions tailored to your unique business needs."/>
              <link rel="canonical" href="/it-Support"/>
               </Helmet>
  
    <div>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
          IT Support Services
          </h1>
        </div>
      </div>
    </div>
  </div>
      {/* Testimonial Start */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
      <div className="it-support-container">
                    <header className="hero">
                        <div className="hero-content">
                            <h1>Your Trusted I.T. Support Service</h1>
                            <p>Professional solutions for your technical challenges.</p>
                        </div>
                    </header>

                    <main>
                        <section className="services">
                            <h2>What We Offer</h2>
                            <div className="services-grid">
                                <div className="service-card">
                                    <img src="https://media.geeksforgeeks.org/wp-content/uploads/20230406152358/CN-(1).jpg" alt="Networking" />
                                    <h3>Networking</h3>
                                    <p>We design, implement, and maintain secure and reliable networks for your business.</p>
                                </div>
                                <div className="service-card">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStFjqs3i0UQ1Gr95xU_BWmvOfgn-jtZWkwrg&s" alt="Troubleshooting" />
                                    <h3>Troubleshooting</h3>
                                    <p>Efficiently diagnosing and resolving your technical issues to minimize downtime.</p>
                                </div>
                                <div className="service-card">
                                    <img src="https://i0.wp.com/www.techwrix.com/wp-content/uploads/2024/07/Cloud-Services.png?fit=600%2C400&ssl=1" alt="Cloud Services" />
                                    <h3>Cloud Services</h3>
                                    <p>Seamlessly transition to cloud-based solutions to enhance flexibility and productivity.</p>
                                </div>
                                <div className="service-card">
                                    <img src="https://www.theforage.com/blog/wp-content/uploads/2022/12/what-is-cybersecurity-1024x631.jpg" alt="Cybersecurity" />
                                    <h3>Cybersecurity</h3>
                                    <p>Protect your data and infrastructure with advanced security measures.</p>
                                </div>
                                <div className="service-card">
                                    <img src="https://www.theforage.com/blog/wp-content/uploads/2022/12/what-is-cybersecurity-1024x631.jpg" alt="Cybersecurity" />
                                    <h3>Server & Storage Infrastructure</h3>
                                    <p>Leverage cutting-edge technologies (Dell EMC, NetApp, HPE, VMware) to deliver innovative solutions tailored to your business needs.</p>
                                </div>
                            </div>
                        </section>

                        <section className="about">
                            <h2>Why Choose Us?</h2>
                            <p>Our team of experienced professionals is dedicated to providing exceptional I.T. support. We prioritize customer satisfaction, offering customized solutions tailored to your unique business needs.</p>
                        
                        </section>

                        {/* About Start */}
            <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/itsm.jpg"
                alt=""
                style={{ objectFit: "cover", borderRadius: '20px' }}
              />
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            <p className="mb-4">
            With our I.T support services offering, Small, Medium and Large-scale enterprises can 
            minimize disruption and maintain a high level of productivity. We provide your business 
            with remote and on-site technical support solutions for all your hardware and software needs. 
            We provide world-class remote technical support and various levels of on-site support. 
            Our professionals have expertise in supporting specialized applications and technology, 
            ranging from servers, desktops, virtualization, storage, cloud, database etc. You can 
            choose from our suites of support programs (monthly, annually or pay-per-use) that fits your needs. 
            <a href='/Contact'>Click here </a>to fill out our project form and our sales specialist will be in touch with you.
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* About End */}
                    </main>

                 
                </div>
      
      </div>
    </div>
    {/* Testimonial End */}
<Form/>
<div className="App">
<PopupWidget
                    url="https://calendly.com/nagspros"
                    rootElement={document.getElementById('root')}
                    text="Schedule a Consultation!"
                    textColor="#ffffff"
                    color="#346815FF"
                />
    </div>
    </div>
    </>
  )
}

export default IT_service
